import type { Argument } from "classnames";
import classNames from "classnames";
import { canUseDOM } from "exenv";
import type { VFC } from "react";
import { useMediaQuery } from "react-responsive";

// This responsive components are hybrid of CSS & `react-responsive`.
// To prevent Layout Shift in first rending, they render DOM in SSR always and control visibility by CSS.
// Use those components instead of using react-responsive directly, if you want to show or hide something in responsive.

// Breakpoint Cheat Sheet
//
// width: 0px              767px 768px   1079px 1080px           over
//        <-- OnlySmartphone -->
//        <--        UnderSmallerPc         -->
//                               <--            OnlyPc            -->
//                                              <-- OverSmallerPc -->

// Have to change variable when changed SCSS breakpoints
export const Breakpoints = {
  smartphone: 767,
  smallerPc: 1079,
};

export const useIsUnderSmartphone = (): boolean => {
  return useMediaQuery({ maxWidth: `${Breakpoints.smartphone}px` });
};

const useIsUnderSmallerPc = (): boolean => {
  return useMediaQuery({ maxWidth: `${Breakpoints.smallerPc}px` });
};

interface Props {
  children: React.ReactNode;
  className?: Argument;
}

export const OnlySmartphone: VFC<Props> = ({ children, className }) => {
  const isSmartphone = useIsUnderSmartphone();
  if (!canUseDOM || isSmartphone) {
    return <div className={classNames("showSmartphoneOnly", className)}>{children}</div>;
  } else {
    return <div className="showSmartphoneOnly" />;
  }
};

export const OnlyPc: VFC<Props> = ({ children, className }) => {
  const isSmartphone = useIsUnderSmartphone();
  if (!canUseDOM || !isSmartphone) {
    return <div className={classNames("showPcOnly", className)}>{children}</div>;
  } else {
    return <div className="showPcOnly" />;
  }
};

export const UnderSmallerPc: VFC<Props> = ({ children, className }) => {
  const isSmallerPc = useIsUnderSmallerPc();
  if (!canUseDOM || isSmallerPc) {
    return <div className={classNames("showSmallerPcUnder", className)}>{children}</div>;
  } else {
    return <div className="showSmallerPcUnder" />;
  }
};

export const OverSmallerPc: VFC<Props> = ({ children, className }) => {
  const isSmallerPc = useIsUnderSmallerPc();
  if (!canUseDOM || !isSmallerPc) {
    return <div className={classNames("showSmallerPcOver", className)}>{children}</div>;
  } else {
    return <div className="showSmallerPcOver" />;
  }
};
